import type { StructuredContentDocument } from '@repo/contracts/multi-use/structured-content/types';
import { css } from '@repo/pandacss/styled-system/css';
import { Badge } from '@repo/ui-v2/Badge';
import { Slideshow } from '@repo/ui-v2/Slideshow';
import { Fragment } from 'react';
import { renderStructuredContent } from '../../rendererContext';
import type { RendererProps } from '../../types';

type Props = StructuredContentDocument<{
  children: StructuredContentDocument[];
  question: string;
  rendererProps?: RendererProps;
}>;

export function FirstPersonPerspective({ props }: Props) {
  const { rendererProps, question, children: perspectiveItems } = props;

  const hasOnlyOneChild = perspectiveItems.length <= 1;

  return (
    <>
      <div className={css({ marginBottom: '1' })}>
        <div
          className={css({
            display: 'flex',
            alignItems: 'center',
            columnGap: '2',
            paddingBottom: '2',
          })}
        >
          <Badge />
          <span
            className={css({
              textStyle: 'bodySmallBold',
              textTransform: 'uppercase',
              letterSpacing: '[.11rem]',
            })}
          >
            More Nerdy Perspective{hasOnlyOneChild ? '' : 's'}
          </span>
        </div>
        {question && <p className={css({ textStyle: 'bodyLarge' })}>{question}</p>}
      </div>
      <Slideshow>
        {perspectiveItems.map((item, index) => (
          <Fragment key={index}>{renderStructuredContent(item, rendererProps)}</Fragment>
        ))}
      </Slideshow>
    </>
  );
}
